import { AuthResult } from "../enums/authResult";

export const defaultHeader = {
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Allow-Headers": "*",
  "Access-Control-Allow-Origin": "*",
};

export const authHeader = () => {
  return {
    "Access-Control-Allow-Credentials": "true",
    "Access-Control-Allow-Headers": "*",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${localStorage.getItem(AuthResult.IdToken)}`,
  };
};

export const cognitoHeader = {
  "Access-Control-Allow-Credentials": "true",
  "Access-Control-Allow-Headers": "*",
  "Access-Control-Allow-Origin": "*",
  "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
  "Content-Length": "134",
  "Content-Type": "application/x-amz-json-1.1",
};
